const constants = {
    START_DATE: "StartDate",
    END_DATE: "EndDate"
};
export { constants as FILTER_CRITERIA_TYPES_CONSTANTS };
